module.exports = __webpack_public_path__ + "media/components/country-flag/static/bw-97ec7213254dfc5cc9c95400a6e15d23.svg";